import useBusinessPostApi from '~/lib/useBusinessPostApi.js';
import * as Toast from '~/lib/Toast.js';
import { formatCurrency } from '~/lib/CurrencyHelpers.js';
import { useEffect, useState } from 'react';
import { useBusinessInfo } from '~/lib/Queries';
import InfoMessageBlock from '~/components/InfoMessageBlock.jsx';
import Select from '~/components/Select';

const SendToSquareTerminalForm = ({ type, id, amount }) => {
    const [hasSent, setHasSent] = useState(false);
    const [deviceId, setDeviceId] = useState(null);

    const { save, isSaving } = useBusinessPostApi(
        `/payments/square-terminal/${type}/${id}`,
    );
    const { data: businessInfoData } = useBusinessInfo();
    const terminalDevices = businessInfoData?.terminalDevices || [];

    function doSend() {
        console.log('Sending...');
        save({
            amount,
            deviceId,
        }).then(() => {
            Toast.success('Successfully sent to Square Terminal');
            setHasSent(true);
        });
    }

    useEffect(() => {
        if (terminalDevices?.length === 1 && !hasSent) {
            // Send immediately!
            doSend();
        }
    }, [terminalDevices?.length]);

    return (
        <div>
            {hasSent && (
                <InfoMessageBlock className="mt-2">
                    <div className="mb-2">
                        Successfully sent order to Square terminal. Please
                        complete the payment on the Square terminal.
                    </div>
                    <div>
                        Any payments made through the terminal will be reflected
                        in Breely.
                    </div>
                </InfoMessageBlock>
            )}

            {!hasSent && (
                <>
                    <div className="text-sm text-gray-500 mt-2 leading-tight">
                        Send this {formatCurrency(amount)} order to Square
                        Terminal to complete payment.
                    </div>
                    {terminalDevices?.length > 1 && (
                        <div className="mt-2">
                            <Select
                                value={deviceId}
                                onChange={setDeviceId}
                                options={terminalDevices.map(d => ({
                                    value: d.device_id,
                                    label: d.name,
                                }))}
                            />
                        </div>
                    )}
                    <button
                        type="button"
                        className="btn-light-pill mt-2"
                        onClick={doSend}
                    >
                        {isSaving ? 'Sending...' : 'Square Terminal Checkout'}
                    </button>
                </>
            )}
        </div>
    );
};

export default SendToSquareTerminalForm;
